import genToken from "@utils/generateToken";

export function getClientId() {
  let clientId = localStorage.getItem("actioncable_client_id");

  if (!clientId) {
    clientId = genToken();
    localStorage.setItem("actioncable_client_id", clientId);
  }

  return clientId;
}
